import React from "react";
import styled from "styled-components";
import { Box, Flex } from "rebass/styled-components";

import { useCs2Hud } from "MVVM/Hooks/useCs2Hud";
import { useCs2HudSettingsModal } from "MVVM/Hooks/useClipQualitySettingsModal";
import { NewPill } from "MVVM/Components/ClipQualitySettings/ClipQualityBubble";
import { analytics } from "MVVM/Analytics";
import cs2Logo from "MVVM/Assets/GameLogos/cs2.svg";

const DISMISS_KEY = "cs2-hud-bubble-dismissed";
const PROMO = { type: "bubble", promotionName: "cs2HudBubble" };

export const Cs2HudBubble = () => {
  const { isLoggedIn, isConfigured } = useCs2Hud();
  const { open: openCs2HudModal } = useCs2HudSettingsModal();
  const [dismissed, setDismissed] = React.useState(() =>
    Boolean(localStorage.getItem(DISMISS_KEY)),
  );

  const visible = isLoggedIn && !isConfigured && !dismissed;

  React.useEffect(() => {
    if (visible) analytics.track("Promotion - Impression", PROMO);
  }, [visible]);

  if (!visible) return null;

  const onDismiss = (e: React.MouseEvent) => {
    e.stopPropagation();
    localStorage.setItem(DISMISS_KEY, "true");
    setDismissed(true);
    analytics.track("Promotion - Dismiss", PROMO);
  };

  const onClick = () => {
    analytics.track("Promotion - Button Click", PROMO);
    openCs2HudModal();
  };

  return (
    <BubbleContainer onClick={onClick}>
      <BubbleIcon>
        <GameLogo src={cs2Logo} alt="" />
      </BubbleIcon>
      <BubbleText>Set up your CS2 HUD &amp; Crosshair</BubbleText>
      <NewPill>NEW</NewPill>
      <DismissButton onClick={onDismiss}>✕</DismissButton>
    </BubbleContainer>
  );
};

const BubbleContainer = styled(Flex)`
  align-items: center;
  background: ${({ theme }) => theme.colors.navy};
  border: 1px solid ${({ theme }) => theme.colors.chalkAlpha20};
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  gap: 8px;
  padding: 8px 16px 8px 12px;
  transition: border-color 0.2s;

  &:hover {
    border-color: ${({ theme }) => theme.colors.envy};
  }
`;

const BubbleIcon = styled(Flex)`
  align-items: center;
  color: ${({ theme }) => theme.colors.envy};
`;

const GameLogo = styled.img`
  height: 20px;
  width: 20px;
`;

const BubbleText = styled(Box)`
  color: ${({ theme }) => theme.colors.ice};
  font-family: "Barlow", sans-serif;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
`;

const DismissButton = styled(Flex)`
  align-items: center;
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.shade400};
  cursor: pointer;
  font-size: 12px;
  height: 20px;
  justify-content: center;
  transition: color 0.15s ease;
  width: 20px;

  &:hover {
    color: ${({ theme }) => theme.colors.ice};
  }
`;
